// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 453 ? "eef9e134" : chunkId) + "." + {"224":"e282fc87a5ff5a4a","453":"5a4e418001987392","460":"77cbea50c7b80d6d","502":"ccd7d86b9890caad","647":"48b81eb624e60dd4","730":"25e908d04fc29df2","831":"28edef2f386f4816"}[chunkId] + ".js";
};